import React from "react";
import { Link, navigate } from "gatsby";
import { RouteComponentProps } from "@reach/router";
import { connect } from "react-redux";
import { MDBRow, MDBCol, MDBBtn } from "mdbreact";
import { Formik, Form } from "formik";
import { Language } from "../../../redux/store/base/language";

// Components
import BasePureComponet from "../../../components/Base/BasePureComponet";
import SEO from "../../../components/Base/SEO";
import Logo from "./../../../assets/images/Logo.svg";
import Illustration_Doctor from "./../../../assets/images/Illustration_Doctor.svg";

// Style
import { InputText, InputPassword } from "../../../components/Custom/Input";
import "./Signin.scss";

interface SigninProps extends RouteComponentProps {
  lang: Language;
  title: string;
}

interface SigninState {}

class Signin extends BasePureComponet<SigninProps> {
  constructor(props: SigninProps) {
    super(props);
  }

  signInForm = {
    userName: "",
    password: "",
  };

  Login = () => {
    navigate("/home");
  };

  render() {
    return (
      <>
        <SEO title={this.props.title} />
        <MDBRow className="signin m-auto" justify={"center"} align="middle">
          <MDBCol className="my-auto ml-4" md={"4"} sm={"8"}>
            <img className="w-100" src={Illustration_Doctor} alt="" />
          </MDBCol>

          <MDBCol className="my-auto p-lg-5 p-md-3" lg={"4"} md={"5"} sm={"12"}>
            <MDBRow>
              <MDBCol className="d-flex justify-content-center">
                <h2 className="title">مرحبا بك في</h2>
                <img className="logo" src={Logo} alt="Logo" />
              </MDBCol>
              {/* <MDBCol order={2} size={"3"}>
              </MDBCol> */}
            </MDBRow>

            <MDBRow>
              <MDBCol order={1}>
                <p className="description">
                  نجعل الحياة الطبية والاجتماعية سهلة للجميع.
                </p>
              </MDBCol>
            </MDBRow>

            <MDBRow justify={"space-around"} align={"stretch"}>
              <Formik
                initialValues={this.signInForm}
                onSubmit={() => {}}
                render={formProp => (
                  <Form>
                    <InputText
                      name="userName"
                      placeholder="البريد الالكتروني او رقم الهاتف"
                    />

                    <InputPassword name="password" placeholder="كلمة المرور" />

                    <MDBRow>
                      <a className="login-form-forgot m-3" href="">
                        هل نسيت كلمة المرور ؟
                      </a>
                    </MDBRow>

                    <MDBBtn
                      color="primary"
                      type={"button"}
                      className="text-center"
                      onClick={this.Login}
                    >
                      تسجيل الدخول
                    </MDBBtn>
                  </Form>
                )}
              />
              <p className="link-after-form mt-3">
                لا تملك حساب؟
                <Link to={"/signup"}>إنشاء حساب جديد</Link>
              </p>
            </MDBRow>
          </MDBCol>
        </MDBRow>
      </>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    lang: state.lang as Language,
    notification: state.notification,
  };
};

export default connect(mapStateToProps)(Signin);
